import { gql } from "@apollo/client";

export const UPDATE_CASE_NOTE_MUTATION = gql`
  mutation UpdateNote($data: UpdateNoteInputData!) {
    updateNote(data: $data) {
      id
      createdAt
      updatedAt
      title
      body
      orgId
      caseId
    }
  }
`;
